import React from "react";
import classes from "./AmityUSPHighlight.module.css";

/**
 * AmityUSPHighlight
 * Standalone highlight block for Amity Wellness' USP.
 *
 * Props:
 * - className?: string
 * - children?: React.ReactNode     (defaults to the provided USP paragraph)
 */
export default function AmityUSPHighlight({
  className = "",
  children,
}) {
  const rootClasses = [classes.root, className].filter(Boolean).join(" ");

  return (
    <section
      className={rootClasses}
      aria-label="Amity Wellness Unique Selling Proposition"
    >
      <p className={classes.body}>
        {children ?? (
          <>
            At Amity Wellness, we are a dedicated{" "}
            <strong>fasting and detox retreat</strong>{" "}
            where <strong>every guest</strong>{" "}
            joins one of our{" "}
            <strong>All-Inclusive transformative cleansing programs</strong>.
            {" "}This creates a unique atmosphere of{" "}
            <strong>focus, support, and shared purpose</strong>.{" "}
            Free from alcohol, smoking, and the temptation of unhealthy foods, you’ll
            be fully immersed in a nurturing community committed to{" "}
            <strong>health, healing, and lasting transformation</strong>.
          </>
        )}
      </p>

      {/* Screen-reader region for optional dynamic subtext */}
      <div className="sr-only" aria-live="polite" />
    </section>
  );
}
